// 重用 file-parse-api 中的类型
export interface SaveParsedFiguresRequest {
    /** 任务ID */
    taskId: string;
    /** 要保存的图片列表 */
    image_s3_keys: string[];
}

export interface FigureImage {
    s3_key: string;
    url: string;
    properties: Record<string, unknown>;
}

export interface FigureAnnotation {
    term_unique_id: string;
    properties: Record<string, unknown>;
}

export interface SavedFigure {
    unique_id: string;
    abstract_figure: boolean;
    image: FigureImage;
    annotation_image_base64: string;
    annotations: FigureAnnotation[];
}

export type SaveParsedFiguresResponse = {
    task_id: string;
    s3_key_to_figure_id_map: Record<string, string>;
    saved_count: number;
};

export interface GetParseImagesRequest {
    /** 任务ID */
    taskId: string;
}

export const ParsedFiguresApi = Symbol.for('ParsedFiguresApi');

export interface GetParseImagesRequestResponse {
    images: {
        image_url: string;
        s3_key: string;
    }[];
}

export interface ParsedFiguresApi {
    /**
     * 保存解析的图片到附图列表
     * @param request 保存请求参数
     * @returns 保存的附图信息
     */
    saveParsedFigures(request: SaveParsedFiguresRequest): Promise<SaveParsedFiguresResponse>;

    /**
     * 获取解析的图片结果
     * @param request 获取请求参数
     * @returns 解析结果
     */
    getParseImages(request: GetParseImagesRequest): Promise<GetParseImagesRequestResponse>;
}
